import PreloadScene from './preloadScene';

export default class BootScene extends Phaser.Scene {
    constructor() {
        super({ key: 'BootScene' });
    }

    create() {
        this.scene.start('PreloadScene');
    }
}
